const words = [
  { beaker: "каплю", ball: "литр" },
  { beaker: "капели", ball: "литра" },
  { beaker: "капель", ball: "литров" },
];
const Endings = (x: number, type: "ball" | "beaker") => {
  if (x >= 11 && x <= 14) {
    return words[2][type];
  }
  const last = x % 10;
  if (last===1) {
    return words[0][type];
  } else if (last >= 2 && last <= 4)
    return words[1][type];
  else return words[2][type];
}
export default Endings;
 